<template>
  <div class="operation-manual">
    <template v-if="isList">
      <div>
        <form action="/">
          <van-search v-model="value" placeholder="请输入名称进行搜索"  @search="onSearch" @clear="onSearch" />
        </form>
        <refresh-list 
          style="margin-top: 2px;"
          :list='list'
          @onLoad="onLoad" 
          @onRefresh="init"
          ref="refreshList"
        >
          <div class="content-box">
            <div class="item-box" v-for="(item,index) in list" :key="index" @click="jumpDetail(item)">
              <van-image class="image" fit="cover" width="100%" height="100px" :src="item.cover" />
              <div class="bottom">{{item.title}}</div>
            </div>
          </div>
        </refresh-list>
      </div>
    </template>
  </div>
</template>

<script>
import refreshList from '@/components/refresh-list/refresh-list'
export default {
	components: {
		refreshList
	},
	data() {
		return {
			value: "",
			list:[],
			pageNum: 1,
			pageSize: 20,
			firstInto: true,
			isList: false
		}
	},
	mounted() {
    this.init();
  },
	methods: {
		onLoad() {
      this.queryLotteryRecordPageList();
    },
		init() {
      this.pageNum = 1;
      this.list = [];
      this.queryLotteryRecordPageList();
    },
    onSearch() {
      this.init();
    },
		queryLotteryRecordPageList() {
			let parmes = {
				filterData: {
					searchKey: this.value
				},
				pageNum: this.pageNum,
				pageSize: this.pageSize
			}
			this.$api.help.queryDocuments(parmes).then(res => {
				if (res.code == 200) {
					if (this.firstInto) {
						this.isList = res.data.list.length ? true : false
						this.firstInto = false
					}
					this.list.push(...res.data.list);
					this.pageNum = res.data.pageNum + 1;
					if(this.isList) this.$refs["refreshList"].complete(res.data);
				} else {
					if(this.isList) this.$refs["refreshList"].onFinish();
				}
			})
			.catch((err) => {
				this.$refs["refreshList"].onFinish();
			});
		},
    async jumpDetail(item) {
      item.searchKey = this.value
			let parmes = {
				path: '/help-video',
				query: item
			}
			if (item.type == 'mp4') {
			 	const {width, height} = await	this.getVideoWidth(item.content)
				parmes.path = '/help-video'
				width > height ? item.screenMode = true : item.screenMode = false
			}else {
				parmes.path = '/help-file'
			}
			this.$router.push(parmes)
    },
		getVideoWidth(fileUrl) {
      return new Promise((resolve, reject) => {
        let url = fileUrl;
        const newvideoUrl = url;
        const videoObj = document.createElement("video");
        videoObj.preload = "metadata";
        videoObj.src = newvideoUrl;
        videoObj.onloadedmetadata = function (evt) {
          URL.revokeObjectURL(newvideoUrl);
          let videoTime = videoObj.duration; // 获取视频的时长
          let width = videoObj.videoWidth; //获取视频的宽
          let height = videoObj.videoHeight; //获取视频的高
          resolve({ width, height });
        };
      });
    },

	},
	filters: {
		status(type) {
			let map = {
				1: '待兑奖',
				2: '已兑换'
			}
			return map[type]
		}	
	}
}
</script>
<style scoped lang="stylus">
.operation-manual {
  /deep/ .van-search {
    padding: 0;
    border-radius: 6px;
    background: transparent;
    .van-search__content {
      border-radius: 6px;
      background: #fff
    }
  }
  .content-box {
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    .item-box {
      width: 48.5%;
      height: 132px;
      box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.1);
      border-radius: 8px;
      margin-top: 10px;
      background: #FFFFFF;
      &:nth-child(odd) {
        margin-right: 3%;
      }
      /deep/ .van-image__loading  {
        border-radius: 8px 8px 0 0;
      }
      /deep/ .van-image__img {
        border-radius: 8px 8px 0 0;
      }

      .bottom {
        width: 100%;
        font-size: 14px;
        color: #333333;
        padding: 6px 13px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
